export default __webpack_public_path__ + "static/banner6_mobile-8a41674694ed096e890eeba9be905b8b.png";